var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9889 29.1671C39.5766 29.1671 41.6741 31.2646 41.6741 33.8523V35.051C41.6741 36.9142 41.0082 38.7158 39.7968 40.1312C36.5272 43.951 31.5539 45.836 25.0012 45.836C18.4472 45.836 13.4763 43.9504 10.2132 40.1289C9.00536 38.7146 8.3418 36.9156 8.3418 35.0556V33.8523C8.3418 31.2646 10.4394 29.1671 13.0269 29.1671H36.9889ZM36.9889 32.2921H13.0269C12.1653 32.2921 11.4668 32.9906 11.4668 33.8523V35.0556C11.4668 36.1717 11.8649 37.251 12.5896 38.0996C15.2007 41.1573 19.2963 42.711 25.0012 42.711C30.7059 42.711 34.8051 41.1573 37.4226 38.0991C38.1497 37.2498 38.5491 36.1687 38.5491 35.051V33.8523C38.5491 32.9906 37.8505 32.2921 36.9889 32.2921ZM25.0012 4.17682C30.7541 4.17682 35.4178 8.84053 35.4178 14.5935C35.4178 20.3465 30.7541 25.0102 25.0012 25.0102C19.2481 25.0102 14.5844 20.3465 14.5844 14.5935C14.5844 8.84053 19.2481 4.17682 25.0012 4.17682ZM25.0012 7.30182C20.9741 7.30182 17.7094 10.5664 17.7094 14.5935C17.7094 18.6206 20.9741 21.8852 25.0012 21.8852C29.0282 21.8852 32.2928 18.6206 32.2928 14.5935C32.2928 10.5664 29.0282 7.30182 25.0012 7.30182Z",
    fill: "#13559F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.b462974ab5805c879793ede03fe14b03.svg";
export { ForwardRef as ReactComponent };